import FeatureIntro from "../../../../components/FeatureIntro";
import ColorSwatchesIcon from "../../../../components/icons/ColorSwatchesIcon";
import QrCodeIcon from "../../../../components/icons/QrCodeIcon";
import UserSyncOnlineIcon from "../../../../components/icons/UserSyncOnlineIcon";

interface GenerateIntroOverlayProps {
  onGetStarted: () => void;
}

const GenerateIntroOverlay = ({ onGetStarted }: GenerateIntroOverlayProps) => {
  const features = [
    {
      icon: (
        <QrCodeIcon className="w-6 h-6" strokeWidth={1.5} color="#4147D5" />
      ),
      title: "Each card has a unique link your guests can view anytime.",
    },
    {
      icon: (
        <ColorSwatchesIcon
          strokeColor="#4147D5"
          strokeWidth={1.3}
          className="w-6 h-6"
        />
      ),
      title: "Once generated, send cards directly via email or WhatsApp.",
    },
    {
      icon: (
        <UserSyncOnlineIcon
          strokeColor="#4147D5"
          strokeWidth={1.5}
          className="w-6 h-6"
        />
      ),
      title:
        "Generating cards is a paid feature; use your credits to unlock and create them.",
    },
  ];

  return (
    <div className="flex items-start justify-center pt-16 px-4">
      <div className="max-w-xs w-full">
        <FeatureIntro
          title="NOTHING YET"
          subtitle="You haven't generated any cards for your guest list yet"
          features={features}
          buttonText="GET STARTED"
          onButtonClick={onGetStarted}
        />
      </div>
    </div>
  );
};

export default GenerateIntroOverlay;
